export const upgradeMember =
{
  path: '/upgrade_kepesertaan',
  name: 'upgrade_kepesertaan',
  hidden: false,
  component: () => import('@/components/upgrade_member/index'),
  meta: {
    title: 'Upgrade Kepesertaan',
    icon: 'fa-address-card',
    roles: ['pasien']
  },
}
export default upgradeMember



// WEBPACK FOOTER //
// ./src/router/modules/upgradeMember.js